import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { apiUrl } from'../Config/Config';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth } from "../Helpers/SettingHelper";
import axios from 'axios';

import {GET_EDITCOMPANY,GET_COMPANYDETAILLIST }  from '../../actions'; 

class CompanyClone extends Component {	
	constructor(props)
	{
		CheckAuth();
		super(props);	
	    const CompanyId = (typeof this.props.match.params.ID === 'undefined') ? '' : this.props.match.params.ID;
		this.state = {		
			company_id: CompanyId,
			userlist: [],
			lenderlist: [],
			brokerlist: [],
			
			Loading:false,
       listIds:[]
		};

        var qs = require('qs');
		var company_id = this.state.company_id;
		axios.get(apiUrl+"company/companyclonedetail?companyid="+company_id).then(res => {
            if(res.data.status == 'success'){
                this.setState({ userlist : res.data.userlist});
                this.setState({ brokerlist : res.data.brokerlist});
                this.setState({ lenderlist : res.data.lenderlist  });
			}
		}); 
    }
    userlist() {
        var userlist = this.state.userlist;
        if (userlist != "undefined" && userlist != null) {
            if (Object.keys(userlist).length > 0) {
              const userlistDetails = userlist.map(
                (userlist, Index) => {
                  let sno = Index+1;
                
                 
                  return (
                    <p>{sno}. {userlist.username} - {userlist.email}</p>
                  );
                }
              );
              return userlistDetails;
            }else{
                return (
                    <p>
                      No Records
                    </p>
                );
            }
          } else {
            return (
                <p>
                  No Records
                </p>
            );
          }
      }
      lenderlist() {
        var lenderlist = this.state.lenderlist;
        if (lenderlist != "undefined" && lenderlist != null) {
            if (Object.keys(lenderlist).length > 0) {
              const lenderlistDetails = lenderlist.map(
                (lenderlist, Index) => {
                  let sno = Index+1;
                
                 
                  return (
                    <p>{sno}. {lenderlist.username} - {lenderlist.email}</p>
                  );
                }
              );
              return lenderlistDetails;
            }else{
                return (
                    <p>
                      No Records
                    </p>
                );
            }
          } else {
            return (
                <p>
                  No Records
                </p>
            );
          }
      }
      brokerlist() {
        var brokerlist = this.state.brokerlist;
        if (brokerlist != "undefined" && brokerlist != null) {
            if (Object.keys(brokerlist).length > 0) {
              const brokerlistDetails = brokerlist.map(
                (brokerlist, Index) => {
                  let sno = Index+1;
                
                 
                  return (
                    <p>{sno}. {brokerlist.username} - {brokerlist.email}</p>
                  );
                }
              );
              return brokerlistDetails;
            }else{
                return (
                    <p>
                      No Records
                    </p>
                );
            }
          } else {
            return (
                <p>
                  No Records
                </p>
            );
          }
      }
 
     
    handleCheckbox = (id) =>{
  
        var listidArr = [...this.state.listIds];
        const index = listidArr.findIndex(list => list === id);
        if(index > -1) {
          
            listidArr = [...listidArr.slice(0, index), ...listidArr.slice(index + 1)]
        } else {
            listidArr.push(id);
        }
        this.setState({listIds: listidArr});
    }
    
  handleSubmit = () => {
	const formdata = this.state;
	var qs = require('qs');
    const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
    };
	var postObject ={
		admin_id: localStorage.getItem('admin_id'),
		company_id : formdata.company_id,
		clone_list : formdata.listIds,
	}
  
  
	let formData = new FormData();
	for(let k in postObject) {
		formData.append(k, postObject[k]);
	}
	axios.post(apiUrl+"company/setcompanycopy",formData,config).then(res => {
    if(res.data.status === "success"){
      $('.success_message').html('<div class="status_sucess"><h3>Company clone successfully</h3></div>');
          setTimeout(
          function() {
            $('.success_message').html(this.props.history.push('/company'));
            
          }
          .bind(this),
          3000
          );
    }else{
      $('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
      
      setTimeout(
      function() {
        $('.success_message').html('');
      }
      .bind(this),
      3000
      );
    }
	});
  }
    render() {
        
        return (
            <div className="wrapper"> 
       
            <Header />
            <MenuSidebar currentpage="companylist" />  
      
          <div id="location-error"></div>
          <div className="content">	
              <div className="content-wrapper">
              <div class="content-wrapper-before"></div>
                  <div className="form-wrapper leaa-admin-head card">
                  <div className="success_message"></div>
                  <div className="title">
                      <h4>Company Clone</h4>				
                  </div>
                   <form className="edit"  onSubmit={ e => { this.handleSubmit(this); e.preventDefault(); }}>             
                   <div className="row">
                   <p>Choose the module to get clone</p>
                 
                    </div>
                   <div className="form-row">
                  <div className="form-left">
                        
                      <div className="form-group">

                      <input className='ms-0' type="checkbox" value="user" onChange={this.handleCheckbox.bind(this,'user')} />	<label>User List:</label>
                          <div className='pl-5'>
                           {this.userlist()}
                          </div>
                      </div>
                      <div className="form-group">					
                         <input className='ms-0' type="checkbox" value="lender" onChange={this.handleCheckbox.bind(this,'lender')} />	<label>Lender List: </label>
                            <div className='pl-5'>
                            {this.lenderlist()}
                            </div>
                        </div>
                     
                  
                     
                  </div>
                    {/* <div className="form-left">
                        <div className="form-group">

                        <input  type="checkbox" value="broker" onChange={this.handleCheckbox.bind(this,'broker')} />	<label>Broker  List:</label>
                        <div className='pl-5'>
                          {this.brokerlist()}
                         </div>
                            
                        </div>
			        </div>	 */}
               
                  </div>	
              {/* ----------------- */}
                  <div className="btn-group export">	
                      <button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" >
                        Clone                                          
                     </button>
                   
                  </div>
                  </form>
                  </div>
                      
              </div>	
          </div>
                   
          </div>
          );
  }
}

export default (withRouter(CompanyClone));